export default __webpack_public_path__ + "static/img-5-627d50fe6ba818ffcfb5434a3521199b.png";